module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {}, [_c('h6', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Product Add-ons")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "clear": "both",
      "margin-top": "1em"
    },
    attrs: {
      "id": "setAddProductAddons"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-sm",
    staticStyle: {
      "float": "left",
      "background": "#5883a0",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('setAddProductAddons')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-sm",
    staticStyle: {
      "float": "right",
      "background": "#008cff",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.addToProductAddons()
      }
    }
  }, [_vm._v("Done, Add Products to Add-ons")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Please select products")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat, casndex) {
    return _c('div', {
      key: casndex,
      staticClass: "card card-flat-pad",
      staticStyle: {
        "height": "auto"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('h5', [_vm._v(_vm._s(cat.business_category_name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-sm",
      staticStyle: {
        "background": "#5883a0",
        "color": "#ffffff"
      },
      on: {
        "click": function($event) {
          _vm.category = cat;
          _vm.getBusinessCategoryProducts('CATSET' + casndex);
          _vm.setMenuTabInnerView(_vm.menu_tab_inner_view['SHCPRDS' + casndex] ? ' ' : ('SHCPRDS' + casndex));
        }
      }
    }, [_vm._v("Select "), _c('i', {
      staticClass: "fa fa-angle-down"
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.menu_tab_inner_view['SHCPRDS' + casndex]) ? _c('div', {
      staticClass: "card"
    }, [(_vm.component_loading['CATSET' + casndex]) ? _c('div', {
      staticClass: "container"
    }, [_vm._m(0, true)]) : _c('div', [_vm._l((cat.category_products), function(prd, prddex) {
      return _c('div', {
        key: prddex,
        staticStyle: {
          "float": "left",
          "width": "30%",
          "clear": "right",
          "padding": "1em"
        }
      }, [(_vm.product.product_id != prd.product_id) ? _c('div', {
        staticClass: "card",
        staticStyle: {
          "padding-top": "1em",
          "width": "auto",
          "height": "auto"
        }
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        on: {
          "click": function($event) {
            _vm.setAddToProductAddons(prd)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "card-avatar-square card-label-avatar"
      }, [(prd.product_images && (prd.product_images.length != 0)) ? _c('img', {
        attrs: {
          "src": prd.product_images[0].product_image
        }
      }) : _c('img', {
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(prd.product_name))])])]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('button', {
      staticClass: "btn sp-button-sm",
      staticStyle: {
        "float": "right",
        "background": "#ff0066",
        "color": "#ffffff"
      },
      on: {
        "click": function($event) {
          _vm.addToProductAddons()
        }
      }
    }, [_vm._v("Done, Add Products to Add-ons")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])], 2), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "5px"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('setAddProductAddons')
      }
    }
  }, [_vm._v("Add Products Add-ons")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_addons && (_vm.product.product_addons.length != 0)) ? _c('div', [_vm._l((_vm.product.product_addons), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "card col-xs-4 card-col-2",
      staticStyle: {
        "margin-bottom": "2.2em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setProduct(product)
        }
      }
    }, [_c('div', {
      staticClass: "card-col-img"
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "max-height": "8em"
      },
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "font-weight": "bolder"
      }
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Stock: ")]), _vm._v(_vm._s(product.product_items[0].product_item_quantity))])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2) : _c('div', [_c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("No product addons")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95da1dc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Account/Sellpoint/Product/ProductAddons.vue
// module id = 616
// module chunks = 0